// TODO: Migrate My Plans to Microapp

import {Component, Input, OnInit} from '@angular/core';
import {ProductCopy, ServiceUsage, SubscriptionWithPaymentDetail} from '@ox/typings';
import {AutoDestroy} from '@ox/utils';
import {ShopDataService} from '@webu/data';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'webu-billing-group',
  templateUrl: './billing-group.component.html'
})
export class BillingGroupComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() group: SubscriptionWithPaymentDetail;
  @Input() userRole: string;
  @Input() serviceUsage: ServiceUsage;
  @Input() isVehicleOverviewPage: boolean;

  loading = true;
  bffCopy: any;

  constructor(
    private shopDataService: ShopDataService
  ) {
  }

  ngOnInit(): void {
    if (this.group) {
      for (const subscription of this.group.subscriptions) {
        if (!subscription.upcomingPlans) {
          subscription.upcomingPlans = [];
        }
      }

      this.shopDataService.getCopyData().pipe(takeUntil(this.destroy$)).subscribe((response) => {
        this.bffCopy = response;
        this.setShowDataUsage(this.bffCopy.products);
      });
    }
    this.loading = false;
  }

  getProductsWithData(products: Array<ProductCopy>) {
    const dataProducts: any[] = [];
    for (const product of products) {
      if (product.type === 'OnStar with Data') {
        dataProducts.push(product.displayName);
      }
    }
    return dataProducts;
  }

  setShowDataUsage(products: Array<ProductCopy>) {
    const dataProducts = this.getProductsWithData(products);
    for (const subscription of this.group.subscriptions) {
      if (subscription.activePlans?.length && dataProducts.includes(subscription.activePlans[0].planId)) {
        subscription.showDataUsage = true;
        return;
      }
    }
  }
}
